<ng-container class="parent" *ngIf="formInfo$ | async as fi">
  <ng-container *ngIf="fi.schema; else placeholder">
    <ng-container *ngIf="referenceDataLoaded; else loadingSpinner">
    <fin-form
      [schema]="fi.schema"
      [options]="fi.options"
      [data]="fi.data"
      [layout]="fi.layout"
      [layoutTemplates]="fi.layoutTemplates"
      (dataChange)="onDataChange($event)"
      (statusChanges)="onStatusChange($event)"
      [components]="addedComponents"
      class="inner-fields"
    >
    </fin-form>
    </ng-container>
    <ng-template #loadingSpinner>
      <div class="loading-spinner-container">
        <finra-spinner [isBackdrop]="false"></finra-spinner>
      </div>
    </ng-template>
  </ng-container>

  <ng-template #placeholder>
    <div class="placeholder-section" role="region" aria-label="Section placeholder">
      <div class="placeholder-card">
        <h2 class="placeholder-card__title">{{ sectionData?.text || 'Section' }}</h2>
        <p class="placeholder-card__description">
          This section is under development. Form fields will appear here once the schema is configured.
        </p>
      </div>
    </div>
  </ng-template>
</ng-container>

<ng-template #updateEmailModal let-email="email" let-disabled="disabled" let-onInput="onInput">
  <div style="padding: 8px 0">
    <label for="notification-email-input" style="display: block; margin-bottom: 4px; font-size: 14px">NMLS Notification Email</label>
    <input
      id="notification-email-input"
      type="email"
      [value]="email"
      (input)="onInput($any($event.target).value); disabled.next(!isValidEmail($any($event.target).value))"
      style="
        width: 100%;
        padding: 0.5rem;
        border: 1px solid #ccc;
        border-radius: 4px;
        font-size: 0.875rem;
        box-sizing: border-box;
      "
    />
  </div>
</ng-template>


<ng-template #addressEditModal let-form="form" let-isMailingAddress="isMailingAddress" let-copyMainAddress="copyMainAddress" let-onDataChange="onDataChange" let-onStatusChanges="onStatusChanges">
  <div *ngIf="isMailingAddress" class="address-edit-copy-btn">
    <button type="button" class="copy-address-btn" aria-label="Copy Main Address to Mailing Address" (click)="copyMainAddress()">
      <finra-icon family="light" icon="Copy" size="xs"></finra-icon>
      Copy Main Address
    </button>
  </div>
  <fin-form
    [schema]="form.schema"
    [layout]="form.layout"
    [data]="addressFormData"
    [options]="form.options"
    (dataChange)="onDataChange($event)"
    (statusChanges)="onStatusChanges($event)"
    class="address-edit-layout"
  >
  </fin-form>
</ng-template>
